<a
  class="d-inline-block color-gray-900"
  [routerLink]="link"
>
  <div class="text">{{ text }}</div>
</a>
